import { useContext } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import Icon from '@common/assets';
import { CalendarContext } from '../../contextWrap';
import { CalendarFilterFormVO } from '@domain/vo/calendar/CalendarFilterFormVO';
import Colors from '@domain/constant/colors';

import useOnMount from '@utils/hooks/useOnMount';
import classnames from 'classnames/bind';
import styles from './calendarHeader.module.scss';
const cx = classnames.bind(styles);

const SearchArea = () => {
  const { filter } = useContext(CalendarContext);
  const { getValues } = useFormContext<CalendarFilterFormVO>();
  const { field: keywordField } = useController({ name: 'keyword' });

  const onClickSearchCloseBtn = () => {
    keywordField.onChange('');
    filter.setLatestFilter(getValues());
  };

  //헤더 영역 클릭 요소 컨트롤
  const onKeyDownInput = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const enterKye = ['NumpadEnter', 'Enter'];
    if (enterKye.includes(event.code)) {
      //react-hook-form handleSubmit실행 방지
      event.preventDefault();
      const inputElement = event.target as HTMLInputElement;
      inputElement.blur(); // 포커스 제거
      filter.setLatestFilter(getValues());
    }
  };

  /**렌더링되고 filter set안해주면 한글자 입력시마다 api콜이 호출되어 재렌더링되는 이슈 */
  useOnMount(() => filter.setLatestFilter(getValues()));

  return (
    <div className={cx('searchWrap')}>
      <span className={cx('icon', 'search')}>
        <Icon name="searchLight" width={24} height={24} fill={Colors.C_COOL_GRAY_70} />
      </span>
      <input
        {...keywordField}
        type="text"
        className={cx('searchInput', { empty: !keywordField.value })}
        placeholder={'기업명을 검색해주세요.'}
        onKeyDown={onKeyDownInput}
        autoComplete="off"
      />
      <a
        className={cx('icon', 'close', { isVisible: keywordField.value })}
        role="button"
        onClick={onClickSearchCloseBtn}
      >
        <Icon name="closeLight" width={24} height={24} fill={Colors.C_COOL_GRAY_70} />
      </a>
    </div>
  );
};

export default SearchArea;
